export function normalizeText(str: string): string {
	return str
		.normalize("NFD") // separa letras dos acentos
		.replace(/[\u0300-\u036f]/g, "") // remove os acentos
		.toLowerCase();
}
